function Help() {
  return (
    <>
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col lg:flex-row gap-6">
        <div className="flex flex-col items-center justify-center w-full">
          <img
            src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/onas-img.png"
            alt="Drzewus - profesjonalne usługi ogrodnicze i pielęgnacja ogrodu"
            className="w-full"
          />
        </div>
        <div className="flex flex-col items-start justify-center gap-2 text-left w-full lg:w-3/4">
          <h2 className="uppercase color-yellow text-xl">O nas</h2>
          <h3 className="text-3xl lg:text-5xl color-green">
            Zadbany <span className="color-yellow">ogród</span> na<br></br>
            długie lata
          </h3>
          <p className="text-gray-600 opacity-80 text-lg">
            Pracujemy wyłącznie na markowych materiałach oraz fachowym sprzęcie.
            Tylko wtedy możemy zagwarantować długotrwałe rezultaty. Dzięki temu
            przez wiele lat będziesz cieszyć się zadbanym ogrodem.
          </p>
          <div className="flex flex-row flex-wrap gap-2">
            <button className="bg-gray-50 border border-gray-100 px-4 py-2 rounded-full color-green">
              wytniemy zbędne drzewa i krzewy
            </button>
            <button className="bg-gray-50 border border-gray-100 px-4 py-2 rounded-full color-green">
              oczyścimy działkę z samosiejek
            </button>
            <button className="bg-gray-50 border border-gray-100 px-4 py-2 rounded-full color-green">
              przeprowadzimy prace ziemne
            </button>
            <button className="bg-gray-50 border border-gray-100 px-4 py-2 rounded-full color-green">
              usuniemy zbędną roślinność
            </button>
            <button className="bg-gray-50 border border-gray-100 px-4 py-2 rounded-full color-green">
              wyrównamy działkę
            </button>
            <button className="bg-gray-50 border border-gray-100 px-4 py-2 rounded-full color-green">
              usuniemy pniaki
            </button>
            <button className="bg-gray-50 border border-gray-100 px-4 py-2 rounded-full color-green">
              ogrodzimy teren
            </button>
            <button className="bg-gray-50 border border-gray-100 px-4 py-2 rounded-full color-green">
              założymy ogród
            </button>
            <a href="/kontakt">
              <button className="bg-green border border-gray-100 px-4 py-2 rounded-full text-white">
                bezpłatna wycena
              </button>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default Help;
